import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const SpotifyCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const success = searchParams.get('success');
    const error = searchParams.get('error');

    if (window.opener) {
      // We're in a popup — notify the parent window
      if (success) {
        window.opener.postMessage({ type: 'spotify-auth-success' }, '*');
      } else {
        window.opener.postMessage({ type: 'spotify-auth-error', error }, '*');
      }
      // Close the popup
      window.close();
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500 mx-auto mb-4"></div>
        <p className="text-gray-400">Completing Spotify authorization...</p>
        <p className="text-gray-400 text-sm mt-2">This window should close automatically.</p>
      </div>
    </div>
  );
};

export default SpotifyCallback;
